import { render, staticRenderFns } from "./Beamer.vue?vue&type=template&id=751c6b05"
import script from "./Beamer.vue?vue&type=script&lang=js"
export * from "./Beamer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports